import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import { KardexTransactionSearchCommand, KardexTransactionSearchResult, KardexRollHistory } from '../../models/kardex-audit/kardex-audit';

@Injectable({
  providedIn: 'root',
})
export class KardexAuditProxyService {
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/kardex-audit';

  constructor(private http: HttpClient) {}

  public search(
    command: KardexTransactionSearchCommand,
    pageNumber = 1,
    pageSize = 50,
  ): Observable<ApiResponse<KardexTransactionSearchResult>> {
    const url = `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.http.post<ApiResponse<KardexTransactionSearchResult>>(url, command);
  }

  public exportToExcel(command: KardexTransactionSearchCommand): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/export-excel`, command, {
      responseType: 'blob',
    });
  }

  public getRollHistory(rollNumber: string): Observable<ApiResponse<KardexRollHistory>> {
    return this.http.get<ApiResponse<KardexRollHistory>>(`${this.baseUrl}/roll-history/${encodeURIComponent(rollNumber)}`);
  }
}
